import { Box, Button, styledComponent } from '@hermes/web-components'

export const DesktopTitle = styledComponent(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  '.MuiTypography-root': {
    fontSize: '14px',
    lineHeight: '20px'
  },
  '.MuiButtonBase-root': {
    padding: '7px 12px',
    lineHeight: '16px',
    fontSize: '12px',
    height: 'auto'
  }
})

export const ListContainer = styledComponent(Box)(({ theme }) => ({
  padding: '16px 24px 0',
  maxHeight: '70vh',
  overflowY: 'auto',
  [theme.breakpoints.down('xs')]: {
    padding: '0 16px'
  }
}))

export const InlineList = styledComponent(Box)(({ theme }) => ({
  cursor: 'pointer',
  padding: '16px 0',
  borderBottom: `1px solid ${theme.palette.divider}`,
  display: 'inline-flex',
  width: '100%',
  '&:last-child': {
    borderBottom: 'none'
  },
  [theme.breakpoints.down('xs')]: {
    justifyContent: 'space-between'
  }
}))

export const BookImageContainer = styledComponent(Box)({
  width: '32px',
  height: '44px',
  position: 'relative',
  overflow: 'hidden',
  borderRadius: '4px',
  marginRight: '15px'
})

export const InlineListInfo = styledComponent(Box)(({ theme }) => ({
  display: 'flex',
  alignSelf: 'center',
  flexDirection: 'column',
  '.books-length': {
    fontSize: '12px',
    lineHeight: '16px',
    color: theme.palette.text.primary
  },
  [theme.breakpoints.down('xs')]: {
    '.MuiTypography-root': {
      fontWeight: 500
    }
  }
}))

export const CreateListButton = styledComponent(Button)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  width: '100%',
  padding: '20px 24px',
  '&:hover': {
    backgroundColor: 'transparent'
  }
}))

export const MobileInlineListInfo = styledComponent(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  fill: theme.palette.neutral.main
}))
